/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { Routes, Route, useParams, useNavigate } from "react-router-dom";
import Step2 from "../screens/step-2/Step2";
import Step3 from "../screens/step-3/Step3";
import HomeScreen from "../screens/HomeScreen";
import { getCookie, setCookie } from "../helper/cookieFunction";
import { handleResetSomeStates } from "../store/action";
import InvoiceFull from "../screens/invoiceFull/invoiceFull";
import Invoice from "../screens/invoice/Invoice";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { useSelector } from "react-redux";
import { RootState } from "../store/reducers";
import { actionCreators } from "../store";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { apiService } from "../services";
import {  sortedByNumber } from "../utils";
import { handleCratedAt, handleTime } from "../helper/time";
import CheckBoxstep1 from "../screens/step-1/checkBoxstep1/CheckBoxstep1";
import { checkExpire, convertTo12HourFormat } from "../utils/genral-functions";

const Routing = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const {
    freezScreenState,
    alertMessageState,
    setBookingDetails,
    langValueState,
    setDeviceId,
    setStoreInfo,
    setTimeCacheCreatedAt,
    setBookingForm,
    setCart,
    setSlotsList,
  } = bindActionCreators(actionCreators, dispatch);
  const appState = useSelector((state: RootState) => state.appReducer);
  const { paymentMethodPopUp, langValue, freezScreen }: any = appState;
  const apiState = useSelector((state: RootState) => state.apiReducer);
  const { storeId, storeInfo } = apiState;
  const { slug, id } = useParams();
  let navigate = useNavigate();
  const handleResetState = () => {
    setBookingForm({});
    setCart([]);
    setSlotsList([]);
  };

  useEffect(() => {
    // handle version system
    const handleVersionSystem = () => {
      const Version: any = "1.0.0.11";
      const currentUrl: any = window.location.host;

      const cookiesVersion = getCookie(`${currentUrl}_version`)
        ? getCookie(`${currentUrl}_version`)
        : false;
      const localStorageVersion = localStorage.getItem(`${currentUrl}_version`)
        ? localStorage.getItem(`${currentUrl}_version`)
        : false;
      if (cookiesVersion || localStorageVersion) {
        if (Version == cookiesVersion || Version == localStorageVersion) {
        } else {
          setCookie(`${currentUrl}_version`, Version, 365);
          localStorage.setItem(`${currentUrl}_version`, Version);
          langValueState("en");
        }
      } else {
        langValueState("en");
        setCookie(`${currentUrl}_version`, Version, 365);
        localStorage.setItem(`${currentUrl}_version`, Version);
        handleResetSomeStates();
      }
    };
    handleVersionSystem();
    if (appState?.timeCacheCreatedAt) {
      let res: any = handleCratedAt(appState?.timeCacheCreatedAt);
      if (res != null) {
        setTimeCacheCreatedAt(res);
        handleResetState();
      }
    } else {
      let date = handleTime();
      setTimeCacheCreatedAt(date);
      handleResetState();
    }
  }, []);

  const onLanguageHandle = () => {
    i18n.changeLanguage(langValue);
    localStorage.setItem("Language", JSON.stringify(langValue));
  };
  useEffect(() => {
    onLanguageHandle();
  }, [langValue]);

  useEffect(() => {
    // document.documentElement.style.setProperty("--th-primary", "#EB5B5E");
  }, [storeId, paymentMethodPopUp]);

  const getStore = async () => {
    if(slug != 'invoice' && slug != 'in' && slug != "undefined" ){
      console.log('slug rotue.',slug)
      freezScreenState(true);
      let id: any = null;
      let response: any = null;
  
      try {
        response = await axios.post(
          `${process.env.REACT_APP_API_URL}/branch/${slug}`,
          {} 
        );
      } catch (e: any) {
        response = e?.response;
        if(slug != "invoice"){
          navigate(`/${slug}/404`);
        }
        console.error("New Api store not found", e);
      }
  
      if (response?.data.success === true) {
        let branchObj: any = response?.data?.data;
        id = branchObj?.id;
        let data = response?.data?.data?.store;
        let bookingObj = response?.data?.data?.booking;
        let bookingData = {
          title: bookingObj?.title ?? null,
          logo: bookingObj?.logo ?? null,
          cover: bookingObj?.cover ?? null,
          description: bookingObj?.description ?? null,
          primaryColor: bookingObj?.primary_color ?? null,
          secondryColor: bookingObj?.secondry_color ?? null,
          bg_image: bookingObj?.bg_image  ?? null
        };
        console.log(bookingData,'bookingData')
          
          if (bookingData?.primaryColor) {
            document.documentElement.style.setProperty("--th-primary", bookingData?.primaryColor);
            console.log('Primary Color Set:', bookingData?.primaryColor); // Confirm it is being applied
        }
        if (bookingData?.secondryColor) {
          document.documentElement.style.setProperty("--th-secondary",bookingData?.secondryColor);
        }
        console.log(data)
        let storeData: any = {
          bookingInfo: bookingData ?? null,
          businessName: data?.business?.name ?? `Not Avalaible`,
          storeId: data?.id ?? `Not Avalaible`,
          slug: data?.slug ?? `Not Avalaible`,
          logo: data?.business?.logo ?? `Not Avalaible`,
          cover: data?.business?.cover ?? `Not Avalaible`,
          primaryColor: data?.business?.color?.primary ?? `Not Avalaible`,
          secondaryColor: data?.business?.color?.secondary ?? `Not Avalaible`,
          currencySymbol: data?.business?.currency == "SAR" ? "SAR" : "KD",
          storeCurrency: { en: "KWD", ar: "دينار" },
          branchName: branchObj?.name ?? `Not Avalaible`,
          branchId: branchObj?.id ?? `Not Avalaible`,
          numberFixed: 3,
          storeBusyTime: data?.busy_till,
          tapKey: branchObj?.tap_account?.public_key,
          tap: branchObj?.tap_account != null,
          otp: !!data?.otp,
          storeCategory: data?.store_category,
          roundLevel:
            data?.rounding != undefined
              ? data?.rounding?.level != undefined
                ? data?.rounding?.level
                : 0.001
              : 0.001,
          roundMethod:
            data?.rounding != undefined
              ? data?.rounding?.method != undefined
                ? data?.rounding?.method
                : "average"
              : "average",
          subCategory: data?.multiple_category,
          categoryProductImage:
            data?.shop_image != undefined || null ? data?.shop_image : true,
          meatSource: data?.meat_source,
          buffetMode: data?.id == 276 ? true : false, //276,
          checkoutShortCut: data?.direct_checkout,
          payments:branchObj?.payments,
          bookingBackground:  bookingData?.bg_image,
          otpProvider: branchObj?.provider ?? data?.provider ?? null,
        };
  
        setStoreInfo(storeData);
  
        let getCategory: any = await apiService.getBookingCategories(id);
  
        if (getCategory?.data?.success == true) {
          let bookingRes = getCategory.data.data;
          let bookingArr: any = [];
          if (bookingRes?.length > 0) {
            bookingRes.forEach((item: any, ind: any) => {
              let useAble: boolean = checkExpire( item?.end_at)
              if(!useAble){
                console.log(item.title)
                console.log(convertTo12HourFormat(item.start_at), 'item.star_at')
              }
              if (item?.active && useAble) {
                let data = {
                  id: item?.id,
                  active: item?.active,
                  days: item?.days ?? [],
                  description: item?.description ?? `Not Avalaible`,
                  bannerDescription: item?.banner_description ?? null,
                  image: item?.image ?? null,
                  price: item?.price ?? `Not Avalaible`,
                  startAt: item?.start_at ?? `Not Avalaible`,
                  endAt: item?.end_at ?? `Not Avalaible`,
                  title: item?.title ?? `Not Avalaible`,
                  typeId: item?.type?.id ?? `Not Avalaible`,
                  typeName: item?.type?.name ?? `Not Avalaible`,
                  slotsType: item?.slot_type?.id ?? `Not Avalaible`,
                  order: item?.order ?? ind,
                  hasSlots: item?.hasSlots,
                  hasExtras: item?.hasExtras,
                  guest: item?.guest ?? null,
                  excludedDate: item?.exclude_dates ?? null,
                  maxDays: item?.max_days ?? 0,
                  menuFile: item?.menu_file ?? null,
                };
                bookingArr.push(data);
              }
            });
          }
          bookingArr = sortedByNumber(bookingArr);
          
          

          setBookingDetails(bookingArr);
          freezScreenState(false);
        } else {
          freezScreenState(false);
          alertMessageState({
            type: "error",
            show: true,
            message: response.data.message,
          });
        }
      } else {
        freezScreenState(false);
        alertMessageState({
          type: "error",
          show: true,
          message: response.data.message,
        });
      }
    }
  };

  useEffect(() => {
    if (slug != 'invoice' && slug != 'inovice' && slug != "undefined" && slug != storeInfo?.slug) {
      getStore();
    }

    let deviceID = uuidv4();
    if (getCookie("deviceId")) {
      setDeviceId(getCookie("deviceId"));
    } else {
      setDeviceId(deviceID);
      setCookie("deviceId", deviceID, 365);
    }
    console.log(slug,'slug',id,'id')
    if(slug == 'inovice'){
      let newUrl = window.location.href.replace('/inovice', '/invoice');
      window.history.replaceState({}, '', newUrl);
    }
    }, [slug]);

  return (
    <div className="loginBackground">
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/step-1" element={<CheckBoxstep1 />} />
        <Route path="/step-2" element={<Step2 />} />
        <Route path="/step-3" element={<Step3 />} />
        <Route path="/step3" element={<Step3 />} />
        <Route path="/:id" element={<Invoice />} />

        <Route path="/:slug/invoice-full" element={<InvoiceFull />} />
        
      </Routes>
    </div>
  );
};

export default Routing;
